import { STATE_LIST } from "../../../../constants";
import CustomSelect from "../../../CustomSelect";
import Flex from "../../../Flex";
import Input from "../../../Input";
import { Button, Grid } from "@mui/material";
import { Formik } from "../../../../utils/formikHelpers";
import { ProviderUserType } from "../../../../constants/ProviderUserSchema";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CustomDatePicker from "../../../CustomDatePicker";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import Text from "../../../Text";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { VisuallyHiddenInput } from "../../../VisuallyHiddenInput";
import { useState } from "react";
import { convertToBase64 } from "../../../../utils/utils";
import RenderWithTooltip from "../../../RenderWithTooltip";
import { DOCUMENT_FORMAT_MAPPER } from "../../../../pages/app/provider/patient/patient-list/patient-chart-new/document/document-constant";
interface LicensedInformationProps {
  formik: Formik<ProviderUserType>;
}

const LicensedInformation = ({ formik }: LicensedInformationProps) => {
  const [fileNames, setFileNames] = useState<string[]>([]);
  function deleteById(id: number) {
    formik.setFieldValue(
      "licenceInformation",
      formik.values.licenceInformation.filter((_, index: any) => {
        return index + 1 !== id;
      })
    );
  }

  function addHandler() {
    formik.validateForm().then((errors) => {
      const hasErrors = Object.keys(errors.licenceInformation ?? {}).length > 0;
      if (!hasErrors) {
        formik.setFieldValue("licenceInformation", [
          ...formik.values.licenceInformation,
          {
            uuid: "",
            licenseState: "",
            licenseNumber: "",
            expiryDate: undefined,
            licenseActiveDate: undefined,
            licenseDocument: undefined,
          },
        ]);
      } else {
        formik.setFieldTouched("licenceInformation", true);
        formik.values.licenceInformation.forEach((_, index) => {
          formik.setFieldTouched(
            `licenceInformation.${index}.licenseState`,
            true
          );
          formik.setFieldTouched(
            `licenceInformation.${index}.licenseNumber`,
            true
          );
          formik.setFieldTouched(
            `licenceInformation.${index}.expiryDate`,
            true
          );
        });
      }
    });
  }

  return (
    <>
      <Flex
        justifyContent={"space-between"}
        width={"100%"}
        alignItems={"center"}
      >
        <Text fontWeight={"medium"}>Licensed Information</Text>
        <Button
          onClick={addHandler}
          startIcon={<AddCircleOutlineRoundedIcon />}
        >
          Add New
        </Button>
      </Flex>

      {/* <Flex alignContent={"center"} alignItems={"center"}> */}
      {formik.values.licenceInformation?.map((ele, index) => {
        return (
          <Grid container spacing={2} key={index} mb={"10px"}>
            <Grid item xs={2} lg={2} xl={2}>
              <CustomSelect
                label="State"
                options={STATE_LIST}
                value={ele.licenseState}
                onChange={(option) => {
                  formik.setFieldValue(
                    `licenceInformation.${index}.licenseState`,
                    option
                  );
                }}
                error={
                  (formik.touched as any)?.licenceInformation &&
                  (formik.errors as any)?.licenceInformation?.[index]
                    ?.licenseState
                }
              />
            </Grid>

            <Grid item xs={3} lg={2} xl={2}>
              <Input
                label="License Name"
                textFieldProps={{
                  placeholder: "Enter License Name",
                  onChange: (e) => {
                    formik.setFieldValue(
                      `licenceInformation.${index}.licenseName`,
                      e.currentTarget.value
                    );
                  },
                  name: "licenseName",
                  value: ele?.licenseName || "",
                }}
              />
            </Grid>
            <Grid item xs={3} lg={2} xl={2}>
              <Input
                label="License Number"
                textFieldProps={{
                  placeholder: "Enter Number",
                  onChange: (e) => {
                    formik.setFieldValue(
                      `licenceInformation.${index}.licenseNumber`,
                      e.currentTarget.value
                    );
                  },
                  name: "licenseNumber",
                  value: ele.licenseNumber,
                }}
                error={
                  (formik.touched as any)?.licenceInformation &&
                  (formik.errors as any)?.licenceInformation?.[index]
                    ?.licenseNumber
                }
              />
            </Grid>
            <Grid item xs={2} lg={2} xl={2}>
              <CustomDatePicker
                label="License Active Date"
                value={ele?.licenseActiveDate}
                onChange={(val) => {
                  formik.setFieldValue(
                    `licenceInformation.${index}.licenseActiveDate`,
                    val
                  );
                  formik.setFieldTouched(
                    `licenceInformation.${index}.licenseActiveDate`,
                    true,
                    false
                  );
                }}
                error={
                  (formik.touched as any)?.licenceInformation?.[index]
                    ?.licenseActiveDate &&
                  (formik.errors as any)?.licenceInformation?.[index]
                    ?.licenseActiveDate
                }
              />
            </Grid>
            <Grid item xs={2} lg={2} xl={2}>
              <CustomDatePicker
                label="Expiry Date"
                value={ele.expiryDate}
                onChange={(val) => {
                  formik.setFieldValue(
                    `licenceInformation.${index}.expiryDate`,
                    val
                  );
                  formik.setFieldTouched(
                    `licenceInformation.${index}.expiryDate`,
                    true,
                    false
                  );
                  if (ele?.licenseActiveDate) {
                    formik.setFieldTouched(
                      `licenceInformation.${index}.licenseActiveDate`,
                      true,
                      false
                    );
                    formik.validateField(
                      `licenceInformation.${index}.licenseActiveDate`
                    );
                  }
                }}
              />
            </Grid>
            <Grid item xs={3} lg={2} xl={2}>
              <Flex alignItems="center" gap={1}>
                <Button
                  sx={{ width: "100%" }}
                  component="label"
                  variant={fileNames?.[index] ? "text" : "outlined"}
                  tabIndex={-1}
                  startIcon={<CloudUploadIcon />}
                >
                  <RenderWithTooltip
                    value={fileNames?.[index] || "Upload File"}
                  />
                  <VisuallyHiddenInput
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={async (event) => {
                      const files = event?.target?.files;
                      if (files) {
                        const fileName = files[0].name;
                        const copiedfiles = [...fileNames];
                        copiedfiles[index] = fileName;
                        setFileNames(copiedfiles);
                        const base64File = await convertToBase64(files[0]);
                        formik.setFieldValue(
                          `licenceInformation.${index}.licenseDocument`,
                          base64File
                        );
                        formik.setFieldValue(
                          `licenceInformation.${index}.licenseDocumentFormat`,
                          DOCUMENT_FORMAT_MAPPER?.[files[0].type] ?? "OTHER"
                        );
                      } else {
                        formik.setFieldValue(
                          `licenceInformation.${index}.licenseDocument`,
                          undefined
                        );
                        formik.setFieldValue(
                          `licenceInformation.${index}.licenseDocumentFormat`,
                          undefined
                        );
                      }
                    }}
                  />
                </Button>
                <DeleteOutlineOutlinedIcon
                  sx={{ cursor: "pointer" }}
                  color={index === 0 ? "disabled" : "error"}
                  onClick={() => {
                    if (index !== 0) {
                      deleteById(index + 1);
                    }
                  }}
                />
              </Flex>
            </Grid>
          </Grid>
        );
      })}
      {/* </Flex> */}
    </>
  );
};

export default LicensedInformation;
